module.exports = __webpack_public_path__ + "img/step2-b.2894f850.png";